module.exports = __webpack_public_path__ + "img/食品-佳宝标签.bbe8db44.jpg";